/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from "@angular/core";
import {VideoComponent} from "./video/video.component";
import {FloatingComponent} from "../floating/floating.component";

/**
 * todo
 */
@Component({
	selector: "aigia-video-table",
	templateUrl: "./video-table.component.html",
	styleUrls: ["../floating/floating.component.css", "./video-table.component.css"],
})
export class VideoTableComponent extends FloatingComponent implements OnInit {

	@Input() public locked: boolean;
	@Input() public videos: string[];
	@Input() public size: number[];
	@Input() public maxSelected: number;

	@Output() public progrssChange = new EventEmitter<boolean>();

	@ViewChildren(VideoComponent) public VideoComponents: QueryList<VideoComponent>;

	public rate: number = 1;

	/**
	 * todo
	 */
	public ngOnInit(): void {
	}

	/**
	 * todo
	 */
	public selected(): string[] {
		let result = this.videos;
		if (this.maxSelected > 0) {
			result = this.videos.slice(0, this.maxSelected);
		}
		return result;
	}

	/**
	 * todo
	 */
	public play(): void {
		this.VideoComponents.forEach((video) => {
			video.play();
		});
	}

	/**
	 * todo
	 */
	public speed(rate: number): void {
		this.VideoComponents.forEach((video) => {
			if ((this.rate + rate) > 0) {
				this.rate = this.rate + rate;
				video.speed(this.rate);
			}
		});
	}

	/**
	 * todo
	 */
	public pause(): void {
		this.VideoComponents.forEach((video) => {
			video.pause();
		});
	}

	/**
	 * todo
	 */
	public top(): void {
		this.VideoComponents.forEach((video) => {
			video.top();
		});
	}

}

